export const MAIN_BLUE = "#507dbe";
export const LIGHT_YELLOW = "#f4f3ec";
export const LIGHT_PINK = "#D69585";
